import { render, staticRenderFns } from "./Pages.vue?vue&type=template&id=2065ff3a&"
import script from "./Pages.vue?vue&type=script&lang=js&"
export * from "./Pages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2065ff3a')) {
      api.createRecord('2065ff3a', component.options)
    } else {
      api.reload('2065ff3a', component.options)
    }
    module.hot.accept("./Pages.vue?vue&type=template&id=2065ff3a&", function () {
      api.rerender('2065ff3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/page/Pages.vue"
export default component.exports